/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from "@emotion/react";
import "twin.macro";

const CometChatBadgeCount = ({ count = 0 }) => {
  return count ? (
    <span tw="inline-flex items-center justify-center h-4 w-4 rounded-full font-size[0.5rem] font-medium bg-primary-500 text-white">
      {count}
    </span>
  ) : null;
};

export default CometChatBadgeCount;
